import React, { Component } from 'react';

class GetCurLocButton extends Component {

  render() {
    let {getCurrentLatLng} = this.props
      return (
        <div className="GetCurLocButton">
          <div onClick={getCurrentLatLng}>
            <i className="fas fa-location-arrow GetCurLocButton-icon"></i>
          </div>
        </div>
      );
    }

}

export default GetCurLocButton;
